import styles from './style.module.scss';

interface Props {
    text: string;
    disabled?: boolean;
    onClick: () => void;
};

/** Pill button that opens the "add a record" form of a section. */
function AddButton(props: Props) {
    const { text, disabled, onClick } = props;

    return (
        <div
            className={styles.add_btn}
            data-is-deactive={disabled}
            onClick={() => !disabled && onClick()}
        >
            <span>{text}</span>
        </div>
    );
};

export default AddButton;
